@if (label()) {
    <p-floatlabel [variant]="labelVariant()">
        <ng-container [ngTemplateOutlet]="control" />
        <label [attr.for]="inputId()">
            {{ label() }}
            @if (required()) {
                <span>*</span>
            }
        </label>
    </p-floatlabel>
} @else {
    <ng-container [ngTemplateOutlet]="control" />
}
<ng-template #control>
    <p-autocomplete
        [inputId]="inputId()"
        [ngModel]="tags()"
        (ngModelChange)="setTags($event)"
        [ngModelOptions]="standaloneNgModel"
        multiple
        fluid
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [invalid]="showInvalid()"
        [suggestions]="filteredOptions()"
        [completeOnFocus]="options().length > 0"
        [showEmptyMessage]="false"
        (completeMethod)="filter($event.query)"
        (keydown.enter)="selectFirst($event)"
        (keydown.tab)="selectFirst($event)"
        (onBlur)="onBlur($event)" />
</ng-template>
@if (showError() && errorMessage(); as message) {
    <small class="kno2-form-control">{{ message }}</small>
}
